import { z } from "zod";
import { PublicIdSchema } from "./common";

export const VehicleStatus = z.enum(["active", "maintenance", "retired"]);

export const Vehicle = z.object({
  id: PublicIdSchema,
  vehicle_number: z.string(),
  vehicle_name: z.string().nullable(),
  max_load_kg: z.string().nullable(),
  // 利用ドライバーの public_id。null = リース(共有プール)。
  user_driver_id: PublicIdSchema.nullable(),
  width_cm: z.number().int().nullable(),
  height_cm: z.number().int().nullable(),
  depth_cm: z.number().int().nullable(),
  // 車両保管場所 (出発・帰着地点)。住所は地図入力で緯度経度を取得する。未設定なら営業所をフォールバック。
  storage_address: z.string().nullable(),
  storage_latitude: z.string().nullable(),
  storage_longitude: z.string().nullable(),
  status: VehicleStatus,
  remarks: z.string().nullable(),
  created_at: z.iso.datetime({ offset: true }),
  updated_at: z.iso.datetime({ offset: true }),
});

export const ListVehiclesInput = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(50),
  status: VehicleStatus.optional(),
  cursor: z.string().optional(),
});

export const CreateVehicleInput = z.object({
  vehicle_number: z.string().min(1).max(20),
  vehicle_name: z.string().max(100).nullable().optional(),
  max_load_kg: z.string().nullable().optional(),
  user_driver_id: PublicIdSchema.nullable().optional(),
  width_cm: z.number().int().min(0).nullable().optional(),
  height_cm: z.number().int().min(0).nullable().optional(),
  depth_cm: z.number().int().min(0).nullable().optional(),
  storage_address: z.string().max(255).nullable().optional(),
  storage_latitude: z.string().nullable().optional(),
  storage_longitude: z.string().nullable().optional(),
  status: VehicleStatus.default("active"),
  remarks: z.string().nullable().optional(),
});

export const UpdateVehicleInput = z.object({
  vehicle_number: z.string().min(1).max(20),
  vehicle_name: z.string().max(100).nullable().optional(),
  max_load_kg: z.string().nullable().optional(),
  user_driver_id: PublicIdSchema.nullable().optional(),
  width_cm: z.number().int().min(0).nullable().optional(),
  height_cm: z.number().int().min(0).nullable().optional(),
  depth_cm: z.number().int().min(0).nullable().optional(),
  storage_address: z.string().max(255).nullable().optional(),
  storage_latitude: z.string().nullable().optional(),
  storage_longitude: z.string().nullable().optional(),
  status: VehicleStatus,
  remarks: z.string().nullable().optional(),
});

export type VehicleDto = z.infer<typeof Vehicle>;
export type VehicleStatusDto = z.infer<typeof VehicleStatus>;
export type CreateVehicleInputDto = z.infer<typeof CreateVehicleInput>;
export type UpdateVehicleInputDto = z.infer<typeof UpdateVehicleInput>;
